export default __webpack_public_path__ + "static/media/dropdowns.06c61c06.gif";